import { render, staticRenderFns } from "./CopySimple.vue?vue&type=template&id=41c5d330"
import script from "./CopySimple.vue?vue&type=script&lang=js"
export * from "./CopySimple.vue?vue&type=script&lang=js"
import style0 from "./CopySimple.vue?vue&type=style&index=0&id=41c5d330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports